export const VIESSMANN_API_AUTH_URL = 'https://iam.viessmann.com/idp/v2/authorize';
export const VIESSMANN_API_API_URL = 'https://iam.viessmann.com/idp/v2/token';
export const VIESSMANN_API_ME_URL = 'https://api.viessmann.com/users/v1/users/me';
export const VIESSMANN_API_CLIENT_ID = '3c987f910d3db0d8897c8bf37e695c28';
export const VIESSMANN_API_SCOPE = 'IoT User offline_access';
